import { find } from 'lodash'
import customFilterResource from '@/api/resources/ui/CustomFilterResource'
import customConfigResource from '@/api/resources/ui/CustomConfigResource'
import sideBarOptions from './sideBarOptions'
import ExpandedSideBar from '@/components/sideBar/ExpandedSideBar'
import CompactSideBar from '@/components/sideBar/CompactSideBar'
import { findNodeByPropertyValue } from '@/components/sideBar/sideBarUtils'

class IncidentSideBarStore {
    constructor() {
        this.sideBars = [ ExpandedSideBar, CompactSideBar ]
        this.loadedCustomOptions = false
        this.loadedConfig = false
        this.defaultOption = findNodeByPropertyValue('id', 'stillOpenAndNotifiedToMe', sideBarOptions.expanded)
        this.state = {
            componentCode: 'uicomponent.incidents.incidentpanel',
            options: sideBarOptions,
            sideBar: ExpandedSideBar,
            fallbackOption: this.defaultOption,
            selectedOption: this.defaultOption,
            sideBarName: sideBarOptions.sideBarName,
            gridRouteName: 'incidentsModule',
            customOptions: [],
            config: this.getDefaultConfig()
        }
    }
    getDefaultConfig() {
        return {
            defaultOptionId: 'stillOpenAndNotifiedToMe',
            sideBarName: ExpandedSideBar.name
        }
    }
    hasLoaded() {
        return this.loadedCustomOptions && this.loadedConfig
    }
    expandSideBar() {
        this.state.sideBar = ExpandedSideBar
        this.saveConfig()
    }
    contractSideBar() {
        this.state.sideBar = CompactSideBar
        this.saveConfig()
    }
    contractSideBarLocally() {
        this.state.sideBar = CompactSideBar
    }
    selectDefaultOption() {
        const option = this.findOptionById(this.state.config.defaultOptionId)
        if (!option) {
            this.selectFallbackOption()
            return
        }
        this.setSelectedOption(option)
    }
    selectFallbackOption() {
        this.setSelectedOption(this.state.fallbackOption)
    }
    findOptionById(id) {
        return findNodeByPropertyValue('id', id, sideBarOptions.expanded) || find(this.state.customOptions, o => o.id === id)
    }
    setSelectedOption(option) {
        // Trigger the watcher in the sidebar to reload the selected option on click
        this.state.selectedOption = null
        this.state.selectedOption = option
    }
    setDefaultOption(option) {
        this.state.config.defaultOptionId = option && option.id
    }
    async loadCustomOptions() {
        const customOptions = await customFilterResource.indexAsOptions(this.state.componentCode)
        this.setCustomOptions(customOptions)
        this.loadedCustomOptions = true
    }
    setCustomOptions(customOptions) {
        this.state.customOptions = customOptions
    }
    async removeCustomOption(option) {
        const index = this.state.customOptions.findIndex(i => i.id === option.id)
        if (index === -1) {
            throw new Error(`custom option with id ${option.id} does not exist`)
        }
        await customFilterResource.deleteCustomOption(this.state.componentCode, option)
        if (option.id === this.state.selectedOption.id) {
            this.setSelectedOption(this.defaultOption)
        }
        this.state.customOptions.splice(index, 1)
    }
    async renameCustomOption(option) {
        await customFilterResource.renameCustomOption(this.state.componentCode, option)
        await this.loadCustomOptions()
        this.updateSelectedOption()
    }
    async updateCustomOption(option, filterModel) {
        return customFilterResource.updateCustomOption(this.state.componentCode, option, filterModel)
    }
    updateSelectedOption() {
        const customOptionSelectedOption = this.state.customOptions.find(customOption => customOption.id === this.state.selectedOption?.id)
        if (customOptionSelectedOption) {
            this.setSelectedOption(customOptionSelectedOption)
        }
    }
    async loadConfig() {
        const customConfig = await customConfigResource.get(this.state.componentCode)
        if (customConfig) {
            this.setConfig({ ...this.getDefaultConfig(), ...customConfig.config })
        } else {
            this.setConfig(this.getDefaultConfig())
        }
        this.loadedConfig = true
    }
    setConfig(config) {
        this.state.config = config
        this.applyConfigSideBar()
    }
    applyConfigSideBar() {
        const sideBar = this.sideBars.find(i => i.name === this.state.config.sideBarName)
        if (!sideBar) {
            throw new Error(`sideBar named ${this.state.config.sideBarName} not found`)
        }
        this.state.sideBar = sideBar
    }
    async saveConfig() {
        const config = {
            ...this.state.config,
            sideBarName: this.getCurrentSideBarName()
        }
        await customConfigResource.save(this.state.componentCode, config)
        this.state.config = config
    }
    getCurrentSideBarName() {
        if (!this.state.sideBar) {
            throw new Error('state.sideBar is not set')
        }
        return this.state.sideBar.name
    }
}

export default new IncidentSideBarStore()
